<script>
import {BModal, BFormTextarea, BFormGroup} from "bootstrap-vue";

export default {
  name: "RejectModal",
  props: {
    id: {
      required: false,
      type: String,
      default: 'modal-reject'
    }
  },
  components: {
    BModal,
    BFormTextarea,
    BFormGroup
  },
  data: () => ({
    comment: '',
    valid: null,
    description: 'Merci d\'indiquer la raison du rejet.'
  }),
  methods: {
    onSubmit(event) {
      if (this.comment !== '') {
        this.valid = null
        this.$emit('ok', {comment: this.comment})
        this.comment = ''
      } else {
        this.valid = false
        event.preventDefault()
      }
    },
    onCancel() {
      this.valid = null
    }
  }
}
</script>

<template>
  <b-modal :id="id" title="Rejet de la saisie" ok-title="Rejeter" cancel-title="Annuler" @ok="onSubmit"
           @cancel="onCancel">
    <b-form-group label="Commentaire" label-for="comment" :description="valid === null && description" :state="valid">
      <b-form-textarea required placeholder="Raison du rejet" id="comment" v-model="comment"
                       :state="valid"></b-form-textarea>
      <b-form-invalid-feedback>
        {{ description }}
      </b-form-invalid-feedback>
    </b-form-group>
  </b-modal>
</template>
